import React from "react";
import { Box } from "@mui/material";
import QualificationItem from "./QualificationItem";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

/**
 * 資格一覧表示（表示専用）
 *
 * - 2カラム（PC）/ 1カラム（SP）
 */
const QualificationList = ({ qualifications = [] }) => {
  const isDesktop = useIsDesktop();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
        rowGap: 0.25,
        columnGap: 4,
      }}
    >
      {qualifications.map((qualification) => (
        <QualificationItem
          key={qualification.id}
          qualification={qualification}
        />
      ))}
    </Box>
  );
};

export default QualificationList;
